import { createSlice } from "@reduxjs/toolkit";

const tourTypeSlice = createSlice({
  name: "tourType",
  initialState: {
    tourTypeList: [],
    toutTypeListAll: [],
    tours: [],
    isFetching: false,
    error: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    getTourType: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getTourTypeSuccess: (state, action) => {
      state.isFetching = false;
      state.tourTypeList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getTourTypeFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getTourTypeAll: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getTourTypeAllSuccess: (state, action) => {
      state.isFetching = false;
      state.toutTypeListAll = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getTourTypeAllFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getTours: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getToursSuccess: (state, action) => {
      state.isFetching = false;
      state.tours = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getToursFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    addTourType: (state) => {
      state.isFetching = true
      state.error = false
    },
    addTourTypeSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    addTourTypeFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    updateTourType: (state) => {
      state.isFetching = true
      state.error = false
    },
    updateTourTypeSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    updateTourTypeFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    removeTourType: (state) => {
      state.isFetching = true
      state.error = false
    },
    removeTourTypeSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    removeTourTypeFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
});

export const tourTypeActions = tourTypeSlice.actions;
export default tourTypeSlice.reducer;
